import { deburr } from "lodash";

export const searchable = (text) =>
  deburr(text || "")
    .toLowerCase()
    .trim();
